import { RandomLayout } from '@antv/layout/lib/layout/random';

export default RandomLayout;
